import firebase from '@/services/firebase';
import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  isEmpty, map, reject, size,
} from 'lodash';
import CampaignButtonsCmp from '../components/CampaignButtons';
import menuContext from '../contexts/menu';

export default function CampaignButtons() {
  const { menuCache } = useContext(menuContext);
  const { fridgeId } = useParams();
  const { menuAdvertisementsDict } = menuCache || {};
  const isLoaded = useRef(false);
  const history = useHistory();

  const [data, setData] = useState([]);

  useEffect(() => {
    const dataRef = firebase.database().ref(`/${process.env.REACT_APP_MODE}/menu/currentCheckoutCampaign/${fridgeId}`);

    dataRef.on('value', (snapshot) => {
      if (size(snapshot.val() || [])) {
        setData((value) => [
          {
            buttonIconUrl: 'MenuAd/limitsale.png',
            description: '期間限定特別活動！',
            id: '限時特惠活動',
            title: '限時特惠活動',
            onClick: () => {
              history.push(`/menu/campaigns/${fridgeId}`);
            },
          },
          ...reject(value, ['id', '限時特惠活動']),
        ]);
      }
    });

    return () => {
      dataRef.off('value');
    };
  }, [fridgeId, history]);

  useEffect(() => {
    if (isEmpty(menuAdvertisementsDict)) return;
    if (isLoaded.current) return;

    const result = map(menuAdvertisementsDict, (advertisement, id) => {
      const { name, description, buttonIconUrl } = advertisement;

      return {
        buttonIconUrl,
        description,
        id,
        title: name,
        onClick: () => {
          history.push(`/menu/ad/${id}`);
        },
      };
    });

    setData((value) => [
      ...result,
      ...value,
    ]);

    isLoaded.current = true;
  }, [menuAdvertisementsDict, history]);

  return <CampaignButtonsCmp data={data} />;
}
